import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { UpdatePlayerProfileInput, UpdatePlayerProfileOutput } from "types/web-app";

export const updatePlayerProfile = async (
  accessToken: string,
  input: UpdatePlayerProfileInput
): Promise<ServiceResponse<UpdatePlayerProfileOutput>> => {
  try {
    const response = await fetchWithAuth("/update-player-profile", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });

    const data = (await response.json()) as ServiceResponse<UpdatePlayerProfileOutput>;
    return data;
  } catch (error) {
    console.error("Failed to update player profile:", error);
    return {
      ok: false,
      message: "Failed to update player profile",
    };
  }
};

